<p-toast [baseZIndex]="2000" position="top-left"></p-toast>
<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="card-panel mt-5">
      <div class="row">
        <div class="col-md-6">
          <lib-page-header page-title="AÇÃO DE GOVERNO"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}" show-change="true"
            image-title="assets/img/preparation.png">
          </lib-page-header>
        </div>
        <div class="col-md-6">
          <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </a>
          <a [routerLink]="['/acoes-governo']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button (click)="submitForm()" class="btn btn-outline-info btn-sm float-right mr-4">
            Salvar ação governo</button>
        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" href="#tab1" role="tab" data-toggle="tab">Dados da ação de governo</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#tab2" role="tab" data-toggle="tab">Fontes de recurso</a>
        </li>
      </ul>

      <!-- Tab panes -->
      <div class="tab-content">
        <div role="tabpanel" class="tab-pane active" id="tab1">
          <br />
          <div class="row">
            <div class="col-md-12">
              <div class="form-row mb-1">
                <div class="form-group col-md-4">
                  <label for="tipo">Tipo<span class="text-danger">*</span></label>
                  <select #tipo_ [compareWith]="compareFn" formControlName="tipo" id="tipo" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.tipo.errors }">
                    <option *ngFor="let item of listaTipos" [value]="item.id">{{item.nome}}</option>
                  </select>
                </div>
                <div class="form-group col-md-6">
                  <label for="alvo">Produto<span class="text-danger">*</span></label>
                  <input formControlName="meta_acao" type="text" class="form-control" id="alvo"
                    [ngClass]="{ 'is-invalid': submitted && f.meta_acao.errors }">
                </div>
                <div class="form-group col-md-2">
                  <label for="unidade_medida">Unidade medida<span class="text-danger">*</span></label>
                  <input formControlName="unidade_medida" type="text" class="form-control" id="unidade_medida"
                    [ngClass]="{ 'is-invalid': submitted && f.unidade_medida.errors }">
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="acao">Descrição da Ação<span class="text-danger">*</span></label>
                  <p-autoComplete formControlName="acao" [field]="acaoAutoComplete.conversor"
                    [suggestions]="acaoAutoComplete.lista" (completeMethod)="acaoAutoComplete.filtrar($event)"
                    placeholder="Informe o nome da ação" inputStyleClass="form-control font-weight-bold"
                    [style]="{ width: '100%' }" [autoHighlight]="true" (onBlur)="existeAcao()"
                    [ngClass]="{ 'is-invalid': submitted && f.acao.errors }" *ngIf="acaoAutoComplete">
                    <ng-template let-acao pTemplate="item">
                      {{acao.codigo}} {{acao.nome}}
                    </ng-template>
                  </p-autoComplete>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="meta">Programa<span class="text-danger">*</span></label>
                  <p-autoComplete formControlName="meta" [field]="metaAutoComplete.conversor"
                    [suggestions]="metaAutoComplete.lista" (completeMethod)="metaAutoComplete.filtrar($event)"
                    placeholder="Informe o nome do programa" inputStyleClass="form-control font-weight-bold"
                    minLength="2" [ngClass]="{ 'is-invalid': submitted && f.meta.errors }" [style]="{ width: '100%' }"
                    [forceSelection]="true" [autoHighlight]="true" *ngIf="metaAutoComplete">
                    <ng-template let-meta pTemplate="item">
                      {{meta.programa.codigo}} {{meta.programa.nome}}
                    </ng-template>
                  </p-autoComplete>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12">
                  <label for="executora">Unidade executora<span class="text-danger">*</span></label>
                  <p-autoComplete formControlName="executora" [field]="executoraAutoComplete.conversor"
                    [suggestions]="executoraAutoComplete.lista" (completeMethod)="executoraAutoComplete.filtrar($event)"
                    [ngClass]="{ 'is-invalid': submitted && f.executora.errors }"
                    placeholder="Informe a unidade executora" inputStyleClass="form-control font-weight-bold"
                    minLength="2" [style]="{ width: '100%' }" [forceSelection]="true" [autoHighlight]="true"
                    *ngIf="executoraAutoComplete">
                    <ng-template let-executora pTemplate="item">
                      {{executora.codigo}} {{executora.nome}}
                    </ng-template>
                  </p-autoComplete>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-12">
                  <table class="table table-eddy table-bordered">
                    <thead>
                      <tr>
                        <th scope="col" colspan="4" style="background-color: #f5f5f5;" class="text-center">
                          META FÍSICA
                        </th>
                      </tr>
                      <tr>
                        <th scope="col" class="text-center">{{login.ppa.ppaperiodo.ano1}}</th>
                        <th scope="col" class="text-center">{{login.ppa.ppaperiodo.ano2}}</th>
                        <th scope="col" class="text-center">{{login.ppa.ppaperiodo.ano3}}</th>
                        <th scope="col" class="text-center">{{login.ppa.ppaperiodo.ano4}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <input unmask="true" [imask]="imaskConfig" formControlName="meta1" type="text"
                            class="form-control form-control-plaintext text-right" id="meta1">
                        </td>
                        <td>
                          <input unmask="true" [imask]="imaskConfig" formControlName="meta2" type="text"
                            class="form-control form-control-plaintext text-right" id="meta2">
                        </td>
                        <td class="text-center">
                          <input unmask="true" [imask]="imaskConfig" formControlName="meta3" type="text"
                            class="form-control form-control-plaintext text-right" id="meta3">
                        </td>
                        <td class="text-center">
                          <input unmask="true" [imask]="imaskConfig" formControlName="meta4" type="text"
                            class="form-control form-control-plaintext text-right" id="meta4">
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-12">
                  <table class="table table-eddy table-bordered">
                    <thead>
                      <tr>
                      <tr>
                        <th scope="col" colspan="4" style="background-color: #f5f5f5;" class="text-center">
                          CUSTO POR EXERCÍCIO
                        </th>
                      </tr>
                      <tr>
                        <th scope="col" class="text-center">{{login.ppa.ppaperiodo.ano1}}</th>
                        <th scope="col" class="text-center">{{login.ppa.ppaperiodo.ano2}}</th>
                        <th scope="col" class="text-center">{{login.ppa.ppaperiodo.ano3}}</th>
                        <th scope="col" class="text-center">{{login.ppa.ppaperiodo.ano4}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <input unmask="true" [imask]="imaskConfig" formControlName="custo1" type="text"
                            class="form-control form-control-plaintext text-right" id="custo1">
                        </td>
                        <td>
                          <input unmask="true" [imask]="imaskConfig" formControlName="custo2" type="text"
                            class="form-control form-control-plaintext text-right" id="custo2">
                        </td>
                        <td class="text-center">
                          <input unmask="true" [imask]="imaskConfig" formControlName="custo3" type="text"
                            class="form-control form-control-plaintext text-right" id="custo3">
                        </td>
                        <td class="text-center">
                          <input unmask="true" [imask]="imaskConfig" formControlName="custo4" type="text"
                            class="form-control form-control-plaintext text-right" id="custo4">
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12">
                  <span class="font-weight-bold" style="font-size: 16px"> CUSTO TOTAL:
                    {{+entidadeForm.get('custo1').value + +entidadeForm.get('custo2').value +
                    +entidadeForm.get('custo3').value + +entidadeForm.get('custo4').value | number:'1.2-2'}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div role="tabpanel" class="tab-pane fade" id="tab2">
          <br />
          <div *ngIf="entidadeForm.get('meta').value">
            <app-acao-fonte-recurso-form [(entidade)]="entidade" [(lista)]="listaAcoesRecurso" [login]="this.login"
              (anoEmitter)="atualizaIndicePPA($event)"
              [funcao]="entidadeForm.get('meta').value.funcao.codigo+' '+entidadeForm.get('meta').value.subfuncao.codigo+' '+entidadeForm.get('meta').value.subfuncao.nome"
              [custo1]="entidadeForm.get('custo1').value" [custo2]="entidadeForm.get('custo2').value"
              [custo3]="entidadeForm.get('custo3').value" [custo4]="entidadeForm.get('custo4').value"
              (atualizarClick)="atualizarLista($event)">
            </app-acao-fonte-recurso-form>
          </div>
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <div id="footer" class="row mt-4">
      <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
        <button (click)="submitForm(true)" class="btn btn-sm btn-secondary">
          <img src="assets/img/global/tick.png" alt="salvar" height="20" width="20">
          Salvar e novo
        </button>
      </div>
    </div>
  </form>
</div>

<app-acao-dlg [login]="login" (atualizarAcao)="updateAcao($event)"></app-acao-dlg>